import React, { useEffect, useMemo, useState } from "react";
import { agency } from "../api";
import RecommendationCard from "../components/RecommendationCard";

const CATEGORIES = ["", "content", "technical", "geo", "upsell", "anomaly_response"];
const PRIORITIES = ["", "high", "medium", "low"];
const STATUSES = ["", "new", "pitched", "in_progress", "completed", "dismissed"];

export default function AgencyRecommendations() {
  const [recos, setRecos] = useState(null);
  const [filters, setFilters] = useState({ status: "new", priority: "", category: "" });
  const [err, setErr] = useState(null);

  async function load() {
    setErr(null);
    try {
      const params = {};
      if (filters.status) params.status = filters.status;
      if (filters.priority) params.priority = filters.priority;
      if (filters.category) params.category = filters.category;
      setRecos(await agency.recommendations(params));
    } catch (e) {
      setErr(e?.response?.data?.detail || e.message);
    }
  }

  useEffect(() => { load(); /* eslint-disable-next-line */ }, [filters]);

  async function onStatusChange(id, body) {
    await agency.updateRecommendation(id, body);
    load();
  }

  const revenueTotal = useMemo(() => {
    if (!recos) return 0;
    return recos.reduce((sum, r) => sum + (r.estimated_revenue_usd || 0), 0);
  }, [recos]);

  return (
    <div className="page">
      <div className="page-head">
        <div>
          <h1>Recommendations pipeline</h1>
          <div className="subtle">
            {recos?.length ?? "…"} items • ~${revenueTotal.toLocaleString()} in estimated revenue
          </div>
        </div>
      </div>

      <div className="card" style={{ marginBottom: 14 }}>
        <div className="grid grid-3">
          <div>
            <label>Status</label>
            <select value={filters.status} onChange={(e) => setFilters({ ...filters, status: e.target.value })}>
              {STATUSES.map((s) => <option key={s} value={s}>{s || "(any)"}</option>)}
            </select>
          </div>
          <div>
            <label>Priority</label>
            <select value={filters.priority} onChange={(e) => setFilters({ ...filters, priority: e.target.value })}>
              {PRIORITIES.map((s) => <option key={s} value={s}>{s || "(any)"}</option>)}
            </select>
          </div>
          <div>
            <label>Category</label>
            <select value={filters.category} onChange={(e) => setFilters({ ...filters, category: e.target.value })}>
              {CATEGORIES.map((s) => <option key={s} value={s}>{s || "(any)"}</option>)}
            </select>
          </div>
        </div>
      </div>

      {err && <div className="error-box">{err}</div>}
      {recos == null ? <p className="subtle">Loading…</p> :
       recos.length === 0 ? <div className="empty">No recommendations match these filters.</div> :
       recos.map((r) => (
         <RecommendationCard key={r.id} reco={r} onStatusChange={onStatusChange} showClient />
       ))}
    </div>
  );
}
